import { useI18n } from '../../i18n/I18nProvider';
import { Screen, ScrollArea, TopBar } from '../../ui/Screen';
import { POLICY, POLICY_UPDATED } from './policyText';

export function PolicyScreen(props: { onBack: () => void }): JSX.Element {
  const { t, lang } = useI18n();
  return (
    <Screen>
      <TopBar title={t('policyTitle')} onBack={props.onBack} />
      <ScrollArea>
        <div className="px-4 pb-6">
          {POLICY[lang].map(([title, body]) => (
            <section key={title} className="pt-5">
              <h2 className="text-[15px] font-bold">{title}</h2>
              <p className="mt-1.5 text-[13.5px] leading-[1.55] text-ink-2">{body}</p>
            </section>
          ))}
          <div className="pt-6 text-[12px] text-ink-3">{POLICY_UPDATED}</div>
        </div>
      </ScrollArea>
    </Screen>
  );
}
